import { render, staticRenderFns } from "./uploadNoCropper.vue?vue&type=template&id=856698be&scoped=true&"
import script from "./uploadNoCropper.vue?vue&type=script&lang=js&"
export * from "./uploadNoCropper.vue?vue&type=script&lang=js&"
import style0 from "./uploadNoCropper.vue?vue&type=style&index=0&id=856698be&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856698be",
  null
  
)

export default component.exports